/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnerscolumnassigned2Inputs */

const en_partnerscolumnassigned2 = /** @type {(inputs: Partnerscolumnassigned2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assigned`)
};

const de_partnerscolumnassigned2 = /** @type {(inputs: Partnerscolumnassigned2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugeordnet`)
};

/**
* | output |
* | --- |
* | "Assigned" |
*
* @param {Partnerscolumnassigned2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnerscolumnassigned2 = /** @type {((inputs?: Partnerscolumnassigned2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnerscolumnassigned2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnerscolumnassigned2(inputs)
	return de_partnerscolumnassigned2(inputs)
});
export { partnerscolumnassigned2 as "partnersColumnAssigned" }